import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { fmtDate, slugToLabel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";

export default function AuditLogs() {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);

  const load = useCallback(() => {
    api.get("/audit-logs", { params: { page, page_size: 25 } }).then((r) => setData(r.data)).catch(() => {});
  }, [page]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-heading text-3xl font-extrabold">Audit Logs</h1>
        <p className="text-muted-foreground text-sm mt-1">System-wide record of administrative actions.</p>
      </div>

      <div className="glass rounded-xl overflow-hidden">
        {!data ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-800 text-left text-xs uppercase tracking-wider text-muted-foreground">
                  <th className="px-4 py-3">Action</th>
                  <th className="px-4 py-3">Entity</th>
                  <th className="px-4 py-3">Actor</th>
                  <th className="px-4 py-3">When</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((a) => (
                  <tr key={a.id} data-testid={`audit-row-${a.id}`} className="border-b border-slate-800/60">
                    <td className="px-4 py-3"><span className="font-mono text-xs text-primary">{slugToLabel(a.action)}</span></td>
                    <td className="px-4 py-3 text-xs text-muted-foreground">{a.entity} <span className="font-mono">{(a.entity_id || "").slice(0, 8)}</span></td>
                    <td className="px-4 py-3 text-xs">{a.actor_name || a.actor_user_id}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground">{fmtDate(a.created_at)}</td>
                  </tr>
                ))}
                {data.items.length === 0 && <tr><td colSpan={4} className="px-4 py-12 text-center text-muted-foreground">No audit entries yet.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {data && data.total_pages > 1 && (
        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground">Page {data.page} of {data.total_pages}</span>
          <div className="flex gap-2">
            <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)} className="border-slate-700"><ChevronLeft className="h-4 w-4" /></Button>
            <Button size="sm" variant="outline" disabled={page >= data.total_pages} onClick={() => setPage(page + 1)} className="border-slate-700"><ChevronRight className="h-4 w-4" /></Button>
          </div>
        </div>
      )}
    </div>
  );
}
